import { useState, useEffect } from 'react'
import type { FC } from 'react'
import cn from 'classnames'
import { Button } from 'components/ui'
import type { TimerRedirectToProps } from '.'
import s from './timer-redirect-to.module.css'

const TimerRedirectTo: FC<TimerRedirectToProps> = ({
  pre = 'Você será redirecionado em',
  seconds = 5,
  className = '',
  onFinish,
  showButton,
  ...rest
}) => {
  const [timeLeft, setTimeLeft] = useState(seconds)

  useEffect(() => {
    // exit early when we reach 0
    if (!timeLeft) {
      onFinish()
      return
    }

    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1)
    }, 1000)

    // eslint-disable-next-line consistent-return
    return () => clearInterval(intervalId)
  }, [timeLeft, onFinish])

  return (
    <div className={cn(s.root, className)} {...rest}>
      {`${pre} ${timeLeft}`}.
      {showButton && (
        <div className={s.footer}>
          Caso não seja redirectionado, clique{' '}
          <Button variant="text" onClick={onFinish}>
            aqui
          </Button>
          .
        </div>
      )}
    </div>
  )
}

export default TimerRedirectTo
